import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { PAComponiFatturaSummaryComponent } from './pa-componi-fattura-summary';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.pa-componi-fattura-summary', {
            url: '/pa-componi-fattura-summary',
            ncyBreadcrumb: {
                label: 'Componi Fattura Riepilogo',
                parent: 'home.fatturazione-pa'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Componi Fattura Riepilogo'
            },
            'views': {
                'homeContent': {
                    template: '<pa-componi-fattura-summary flex="100"></pa-componi-fattura-summary>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const PAComponiFatturaSummaryModule: string = ng
    .module('pa-componi-fattura-summary', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('paComponiFatturaSummary', PAComponiFatturaSummaryComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/pa-componi-fattura-summary/pa-componi-fattura-summary.module.ts